// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header-lite_wrapper__1F0_i","imageCity":"header-lite_imageCity__3iWcc"};